// TODO: Fix this the next time the file is edited.
import invariant from 'invariant';

import { fetchCurrentUser } from 'api/currentUser';
import { SearchResults } from 'api/search';
import algoliaSearch from 'utils/algoliaSearch';
import { configString } from 'utils/config';
import { isEnabled as daysEnabled } from 'utils/idealistdayevents';
import getSearchConfig from 'utils/search/getSearchConfig';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Dispatch, GetState } from '../..';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { updateCurrentUser } from '../currentUser';

// Types

export type State = {
  groupId?: string;
  apiKey?: string;
  pageIndex: number;
  type: string;
  status: string;
  query: string;
  results: SearchResults | null | undefined;
  typeCounts: Record<string, number> | null | undefined;
  filters: {
    isFetching: boolean;
    status: Array<string>;
  };
};

type SearchStartAction = {
  type: 'GROUP_DASHBOARD_SEARCH_START';
  groupId: string;
  apiKey: string;
  listingType: string;
  status: string;
  query: string;
  pageIndex: number;
};
type SearchSuccessAction = {
  type: 'GROUP_DASHBOARD_SEARCH_SUCCESS';
  results: SearchResults;
};
type SetTypeCountsAction = {
  type: 'GROUP_DASHBOARD_SET_TYPE_COUNTS';
  typeCounts: Record<string, number>;
};
type FacetsStartAction = {
  type: 'GROUP_DASHBOARD_FACETS_START';
};
type FacetsSuccessAction = {
  type: 'GROUP_DASHBOARD_FACETS_SUCCESS';
  facets: {
    status: Record<string, number>;
  };
};
export type Action =
  | SearchSuccessAction
  | SearchStartAction
  | SetTypeCountsAction
  | FacetsStartAction
  | FacetsSuccessAction;

// Reducer

const initialState = {
  pageIndex: 0,
  type: 'ALL',
  status: 'ALL',
  query: '',
  results: null,
  typeCounts: null,
  filters: {
    status: [],
    isFetching: false,
  },
};

export default function searchReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = initialState,
  action: Action
) {
  switch (action.type) {
    case 'GROUP_DASHBOARD_SEARCH_START': {
      const { groupId, apiKey, listingType, status, query, pageIndex } = action;
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line prefer-object-spread
      return Object.assign({}, state, {
        groupId,
        apiKey,
        pageIndex,
        type: listingType,
        status,
        query,
        results: state.results,
        typeCounts: groupId === state.groupId ? state.typeCounts : null,
      });
    }

    case 'GROUP_DASHBOARD_SEARCH_SUCCESS':
      return { ...state, results: action.results };

    case 'GROUP_DASHBOARD_SET_TYPE_COUNTS':
      return { ...state, typeCounts: action.typeCounts };

    case 'GROUP_DASHBOARD_FACETS_START': {
      return { ...state, filters: { ...state.filters, isFetching: true } };
    }

    case 'GROUP_DASHBOARD_FACETS_SUCCESS': {
      const groupStatuses: Array<string> = Object.keys(
        action.facets.status || {}
      );
      return {
        ...state,
        filters: {
          status: groupStatuses,
          isFetching: false,
        },
      };
    }

    default:
      // this causes a flow error if there are any unhandled actions
      action as never;

      return state;
  }
}

// Actions

const getQueryOptions = ({
  type,
  status,
  pageIndex,
}: {
  type: string;
  status: string;
  pageIndex: number;
}): QueryOptions => {
  const filters = [];

  if (type !== 'ALL') {
    filters.push(`type:'${type}'`);
  }

  if (status !== 'ALL') {
    filters.push(`status:'${status}'`);
  }

  const attributesToRetrieve = [
    'objectID',
    'type',
    'status',
    'name',
    'city',
    'state',
    'country',
    'published',
    'created',
    'expires',
    'updated',
    'inCartOf',
  ];
  return {
    index: configString('algolia', 'orgIndexName'),
    // Yes, org
    hitsPerPage: 20,
    page: pageIndex,
    attributesToRetrieve,
    filters: filters.join(' AND '),
  };
};

const fetchTypeCounts = (
  apiKey: string,
  groupId: string,
  dispatch: Dispatch
) => {
  const searchConfig = getSearchConfig(apiKey);
  const queryOptions = {
    index: configString('algolia', 'orgIndexName'),
    // Yes, org
    facets: 'type',
    hitsPerPage: 0,
  };
  return algoliaSearch(searchConfig, '', queryOptions, false, () =>
    fetchCurrentUser().then((fetchedCurrentUser) => {
      dispatch(updateCurrentUser(fetchedCurrentUser));
      return fetchedCurrentUser.groups.filter((g) => g.id === groupId)[0]
        .searchApiKey;
    })
  )
    .then(({ facets: { type } }) => ({
      JOB: (type && type.JOB) || 0,
      INTERNSHIP: (type && type.INTERNSHIP) || 0,
      VOLOP: (type && type.VOLOP) || 0,
    }))
    .catch((error) => {
      throw error;
    });
};

export const search =
  ({
    groupId,
    query,
    status,
    type,
    pageIndex,
    force,
  }: {
    groupId: string;
    query: string;
    status: string;
    type: string;
    pageIndex: number;
    force: boolean;
  }) =>
  (dispatch: Dispatch, getState: GetState) => {
    const {
      groupDashboard: { search: searchInfo },
      currentUser: { groups },
    } = getState();

    if (
      groupId === searchInfo.groupId &&
      status === searchInfo.status &&
      type === searchInfo.type &&
      query === searchInfo.query &&
      pageIndex === searchInfo.pageIndex &&
      searchInfo.results &&
      !force
    ) {
      return;
    }

    const group = groups && groups.find((o) => o.id === groupId);
    invariant(group, 'Invalid group id');
    const apiKey = group.searchApiKey;

    if (groupId !== searchInfo.groupId || !searchInfo.typeCounts) {
      fetchTypeCounts(apiKey, groupId, dispatch).then((typeCounts) => {
        dispatch({
          type: 'GROUP_DASHBOARD_SET_TYPE_COUNTS',
          typeCounts,
        });
      });
    }

    dispatch({
      type: 'GROUP_DASHBOARD_SEARCH_START',
      groupId,
      apiKey,
      listingType: type,
      status,
      query,
      pageIndex,
    });
    const queryOptions = getQueryOptions({
      type,
      status,
      pageIndex,
    });
    const searchConfig = getSearchConfig(apiKey);

    if (!daysEnabled()) {
      if (queryOptions.filters === undefined) {
        queryOptions.filters = '';
      }

      if (queryOptions.filters) {
        queryOptions.filters += ' AND ';
      }

      queryOptions.filters += 'NOT type:"IDEALIST_DAY_EVENT"';
    }

    algoliaSearch(searchConfig, query, queryOptions, true, () =>
      fetchCurrentUser().then((fetchedCurrentUser) => {
        dispatch(updateCurrentUser(fetchedCurrentUser));
        return fetchedCurrentUser.groups.filter((g) => g.id === groupId)[0]
          .searchApiKey;
      })
    )
      .then((results) => {
        dispatch({
          type: 'GROUP_DASHBOARD_SEARCH_SUCCESS',
          results,
        });
      })
      .catch((error) => {
        throw error;
      });
  };
export const fetchFacets =
  (groupId: string) => (dispatch: Dispatch, getState: GetState) => {
    const {
      groupDashboard: {
        search: {
          filters: { isFetching },
        },
      },
      currentUser: { groups },
    } = getState();
    const index = configString('algolia', 'orgIndexName');
    invariant(groupId, 'groupId is not set');
    const group = groups && groups.find((o) => o.id === groupId);
    invariant(group, 'Invalid group id');
    const apiKey = group.searchApiKey;
    if (isFetching) return;
    dispatch({
      type: 'GROUP_DASHBOARD_FACETS_START',
    });
    const searchConfig = getSearchConfig(apiKey);
    algoliaSearch(
      searchConfig,
      '',
      {
        index,
        facets: '*',
        hitsPerPage: 0,
        page: 0,
        attributesToRetrieve: '*',
        // if they are staff then we need to filter results by group Id
        filters: '', // if staff is added, use the following addition => staff ? `groupID:'${groupId}'` : ''
      },
      false,
      () =>
        fetchCurrentUser().then((fetchedCurrentUser) => {
          dispatch(updateCurrentUser(fetchedCurrentUser));
          return fetchedCurrentUser.groups.filter((g) => g.id === groupId)[0]
            .searchApiKey;
        })
    )
      .then(({ facets }) => {
        dispatch({
          type: 'GROUP_DASHBOARD_FACETS_SUCCESS',
          facets,
        });
      })
      .catch((error) => error);
  };
